import constants from '../../constants';

const initialState = {
  deals: [],
  views: [],
  error: null,
  dealStats: {},
  pipelines: [],
  loading: false,
  properties: [],
  singleDeal: null,
  pipelineBoard: {},
  pipelineMetrics: [],
  isDeleteDeals: false,
  pagination: { page: 1, limit: 50, total: 0, pages: 0 },

  dealsTable: [],
  viewFilters: {},

  newDealModal: false,
  pipelineSettingsModal: false,
  createPipelineModal: false,
  currentPipeline: null,

  // Filter state
  filters: {
    filterGroups: [],
    groupOperator: 'OR'
  },
  advanceFilter: '',
  activeFilters: null,
  filter: constants['initialAdvanceFilter'],

}

const DealsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DEALS_TABLE':
      return {
        ...state,
        dealsTable: action['payload']['deals'] || [],
        pagination: action['payload']['pagination'] || {},
        properties: action['payload']['properties'] || [],
        viewFilters: action['payload']['filters'] || {},
      }

    case 'SET_PIPELINE_BOARD':
      return {
        ...state,
        loading: false,
        pipelineBoard: action['payload'] || {},
        pagination: action['payload']['pagination'] || {},
      }

    case 'SET_SINGLE_DEAL':
      return {
        ...state,
        loading: false,
        singleDeal: action['payload'],
      }

    case 'SET_PIPELINES':
      return {
        ...state,
        // loading: false,
        pipelines: action['payload']
      }

    case 'SET_PIPELINE_BY_ID':
      return {
        ...state,
        loading: false,
        currentPipeline: action['payload']
      }

    case 'SET_PIPELINE_SETTINGS_MODAL':
      return {
        ...state,
        pipelineSettingsModal: action['payload']
      }

    case 'SET_CREATE_PIPELINE_MODAL':
      return {
        ...state,
        createPipelineModal: action['payload']
      }

    case 'SET_DEAL_STATS':
      return {
        ...state,
        dealStats: action['payload']
      }

    case 'SET_NEW_DEAL_MODAL':
      return {
        ...state,
        newDealModal: action['payload']
      }

    case 'SET_PIPELINE_METRICS':
      return {
        ...state,
        pipelineMetrics: action['payload']
      }

    case 'SET_DEAL_VIEWS':
      return {
        ...state,
        views: action['payload']
      }

    case 'DEALS_LOADING':
      return {
        ...state,
        loading: action['payload'] ? true : false
      }

    case 'DEALS_ERROR':
      return {
        ...state,
        loading: false,
        error: action['payload'],
      }

    case 'SET_ADVANCE_FILTER_MODULE':
      return {
        ...state,
        advanceFilter: action['payload']
      }

    case 'SET_DEAL_FILTER':
      return {
        ...state,
        filter: action['payload']
      }

    case 'SET_DEAL_FILTERS':
      return {
        ...state,
        filters: action['payload']
      }

    case 'CLEAR_DEAL_FILTERS':
      return {
        ...state,
        filters: {
          filterGroups: [],
          groupOperator: 'OR'
        },
        activeFilters: null
      }

    case 'APPLY_DEAL_FILTERS':
      return {
        ...state,
        activeFilters: action['payload'],
        loading: true
      }

    case 'TOGGLE_DELETE_DEALS':
      return {
        ...state,
        isDeleteDeals: action['payload']
      }


    default:
      return state
  }
}

export default DealsReducer